import { nullable, struct, UnknownRecord } from 'io-ts/Decoder';

export const Request = struct({
	config: nullable(UnknownRecord),
});
